/**
 * B.S.C. Laboratories — Shop grid filtering.
 * Client-side show/hide based on Status and Category checkboxes, plus a simple search box.
 * No page reload; scales fine for a catalog this size. Revisit with real faceted search
 * (Shopify's /search or a filter app) once the catalog grows significantly.
 */
(function () {
  var grid = document.querySelector('[data-bsc-shop-grid]');
  if (!grid) return;

  var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-bsc-card]'));
  var statusInputs = document.querySelectorAll('[data-bsc-filter-status]');
  var categoryInputs = document.querySelectorAll('[data-bsc-filter-category]');
  var searchInput = document.querySelector('[data-bsc-shop-search]');

  function checkedValues(nodeList) {
    return Array.prototype.slice
      .call(nodeList)
      .filter(function (el) { return el.checked; })
      .map(function (el) { return el.getAttribute('data-bsc-filter-status') || el.getAttribute('data-bsc-filter-category'); });
  }

  function applyFilters() {
    var statuses = checkedValues(statusInputs);
    var categories = checkedValues(categoryInputs);
    var query = searchInput ? searchInput.value.trim().toLowerCase() : '';

    cards.forEach(function (card) {
      var matchesStatus = statuses.length === 0 || statuses.indexOf(card.getAttribute('data-status')) !== -1;
      var matchesCategory = categories.length === 0 || categories.indexOf(card.getAttribute('data-category')) !== -1;
      var matchesSearch = !query || card.getAttribute('data-title').indexOf(query) !== -1;
      card.style.display = matchesStatus && matchesCategory && matchesSearch ? '' : 'none';
    });
  }

  statusInputs.forEach(function (el) { el.addEventListener('change', applyFilters); });
  categoryInputs.forEach(function (el) { el.addEventListener('change', applyFilters); });
  if (searchInput) searchInput.addEventListener('input', applyFilters);
})();
